var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-item",on:{"click":function($event){return _vm.$emit('item-click', _vm.item)}}},[_c('div',{staticClass:"course-pic",style:({
      background: '#000 url(' + _vm.backImg + ') no-repeat center/contain'
    })}),_c('div',{staticClass:"course-text"},[_c('span',{class:['course-item-text', 'van-multi-ellipsis--l2', 'item-text-one-style']},[_vm._v(_vm._s(_vm.item.title || _vm.item.courseName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }